import { BaseService } from '@/services/base.service'

export class InstallMentService {
  static async checkInfoCard (params) {
    try {
      const response = await BaseService.request().post('v1/installment/checkinfocard', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getPlanByMerchant (params) {
    try {
      const response = await BaseService.request().post('v1/installment/get-plan-by-merchant', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getPlanByMerchantLink (params) {
    try {
      const response = await BaseService.request().post('v1/installment/get-plan-method-link-car-by-merchant', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getBinNotSupport () {
    try {
      const response = await BaseService.request().get('v1/installment/getbin-notsupport')
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getBankSupport () {
    try {
      const response = await BaseService.request().post('v1/installment/get-bank-support')
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getInstallmentByBank (params) {
    try {
      const response = await BaseService.request().post('v1/installment/get-installment-by-bank', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
